import { useState } from "react";

export interface MonthOption {
  value: string;
  label: string;
}

const useDashboardFilters = () => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const [selectedYear, setSelectedYear] = useState(currentYear.toString());
  const [selectedMonth, setSelectedMonth] = useState(currentMonth.toString());
  const [selectedProperties, setSelectedProperties] = useState<string[]>([]);
  const [selectedOrganizations, setSelectedOrganizations] = useState<string[]>([]);

  const yearOptions = Array.from({ length: 3 }, (_, i) => currentYear - i);

  const monthOptions: MonthOption[] = [
    { value: "1", label: "Enero" },
    { value: "2", label: "Febrero" },
    { value: "3", label: "Marzo" },
    { value: "4", label: "Abril" },
    { value: "5", label: "Mayo" },
    { value: "6", label: "Junio" },
    { value: "7", label: "Julio" },
    { value: "8", label: "Agosto" },
    { value: "9", label: "Septiembre" },
    { value: "10", label: "Octubre" },
    { value: "11", label: "Noviembre" },
    { value: "12", label: "Diciembre" },
  ];

  const handlePropertyChange = (value: string) => {
    if (value === "all") {
      setSelectedProperties([]);
    } else {
      setSelectedProperties([value]);
    }
  };

  return {
    selectedYear,
    setSelectedYear,
    selectedMonth,
    setSelectedMonth,
    selectedProperties,
    setSelectedProperties,
    selectedOrganizations,
    setSelectedOrganizations,
    yearOptions,
    monthOptions,
    handlePropertyChange,
  };
}

export default useDashboardFilters;